import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { filter, orderBy } from 'lodash';
import styles from './styles.css';
import ReasonCellRender from './ReasonCellRenderer';

class FeedbackRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
    this.requestOpportunityFeedbacks = this.requestOpportunityFeedbacks.bind(this);
    this.handleRowGroupOpened = this.handleRowGroupOpened.bind(this);
    this.handleRequestShowInsight = this.handleRequestShowInsight.bind(this);
  }

  componentDidMount() {
    this.props.api.addEventListener('rowGroupOpened', this.handleRowGroupOpened);
    this.checkProps();
  }
  componentWillUnmount() {
    this.props.api.removeEventListener('rowGroupOpened', this.handleRowGroupOpened);
  }

  handleRowGroupOpened() {
    this.checkProps();
  }

  handleRequestShowInsight(insightId) {
    this.props.requestShowInsight(this.props.data.opportunity_id, insightId);
  }

  checkProps() {
    const { node, context: { detailModes }, data, mode } = this.props;
    const currentMode = data ? detailModes[data.opportunity_id] : { expanded: false };
    const { expanded } = node;
    this.setState({ expanded: expanded && mode === currentMode });
  }

  requestOpportunityFeedbacks(e) {
    e.preventDefault();
    const { expanded } = this.state;
    const { data, mode } = this.props;
    this.props.requestShowFeedback(mode, data, !expanded);
  }

  renderValue() {
    const { 
      data, field, isClient,
    } = this.props;
    if (!data) {
      return null;
    }
    const { expanded } = this.state;
    const value = data[field];
    if (!value || value === undefined) {
      return <Fa name="spinner" spin className="text-muted" />;
    }
    const clientReasons = filter(value, isClient ? { is_client: true } : { is_client: false, is_strongest: true });

    if (!clientReasons || clientReasons.length === 0) {
      return null;
    }

    const clientMajorReasons = orderBy(clientReasons, ['impact', 'label'], ['asc', 'asc']);
    let str = (<em>No major reasons</em>);
    const total = clientMajorReasons.length;
    
    if (total) {
      str = (
        <ReasonCellRender
          value={clientMajorReasons}
          isClient={isClient}
          key="reasons"
          requestShowInsight={this.handleRequestShowInsight}
        />
      );
    }
    return [
      (
        <a
          href=""
          onClick={this.requestOpportunityFeedbacks}
          key="btn"
          className={styles.expandBtn}
        >
          <Fa name={expanded ? 'minus-square-o' : 'plus-square-o'} />
        </a>
      ),
      str,
    ];
  }

  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderValue();
    }
    return null;
  }
}

FeedbackRenderer.propTypes = {
  data: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
    expanded: PropTypes.bool,
  }),
  api: PropTypes.shape({
    addEventListener: PropTypes.func.isRequired,
    removeEventListener: PropTypes.func.isRequired,
  }).isRequired,
  field: PropTypes.string.isRequired,
  isClient: PropTypes.bool,
  mode: PropTypes.string.isRequired,
  context: PropTypes.shape({
    detailModes: PropTypes.shape({}).isRequired,
  }).isRequired,
  requestShowFeedback: PropTypes.func.isRequired,
  requestShowInsight: PropTypes.func.isRequired,
};
FeedbackRenderer.defaultProps = {
  data: null,
  node: null,
  isClient: false,
  requestShowInsight: () => {},
};

export default FeedbackRenderer;
